import * as Yup from "yup"

const RegisterAssociationRepresentativeFormValidationShema = Yup.object().shape(
  {
    sector: Yup.object().typeError("Field of activity is required."),
  },
)

export default RegisterAssociationRepresentativeFormValidationShema
